document.addEventListener('DOMContentLoaded', () => {
  if (window.localStorage) {
    const sign_up_disabled_at = localStorage.getItem('sign_up_disabled_at');
    if (sign_up_disabled_at !== null && typeof Number(sign_up_disabled_at) === 'number') {
      document.getElementById('sign_up_form').addEventListener('submit', (event) => {
        if (new Date().getTime() < Number(sign_up_disabled_at) * 1000) {
          event.preventDefault();
          alert("連続でアカウントを登録することはできません");
        }
      });
    }
  }
});
